import React, { Component } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './SerieFacturaForm';
import EditarSerieFacturaForm from './SerieFacturaForm';

export default class SerieFacturaCrear extends Component {
    state = {
        editar: false
    };

    componentWillMount(){
        if(this.props.match.params.id){
            this.props.leer(this.props.match.params.id);
            this.setState({
                editar: true,
            });
        }
    }

    actualizar = (data) => {
        this.props.editar(data, this.props.match.params.id)
    };

    componentWillUnmount(){
        this.props.cleanForm();
    }

    render() {
        const { crear, update } = this.props;
        const { updateData, loader } = this.props;
        return (
            <div className="mb-4 col-12 mt-4">
                <CardForm>
                    <LoadMask loading={loader} blur>
                        {
                        this.state.editar ?
                            <EditarSerieFacturaForm
                                onSubmit={this.actualizar}
                                updateData={updateData}
                                editando={true}
                            />
                            :
                            <Form
                                onSubmit={crear}
                            />
                        }
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
